import { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import Button from "components/Button";
import Icon from "components/Icon";
import CommentsPanel from "./CommentsPanel";
import { useReportContext } from "context/ReportContext";
import useReports from "services/ReportService";
import { sections as generateSections } from "./sections/sections";
import Block from "./blocks/Block";
import { NavigationScrollListener } from "context/SidebarContext";
import Footer from "layouts/containers/Footer";

export default function Report() {
  const [commentsOpen, setCommentsOpen] = useState(false);
  const { id, tab } = useParams();

  const navigate = useNavigate();

  const { getReport } = useReports();
  const { report, setReport, section, setSection, generateHcs, generateTags } = useReportContext();
  const [loading, setLoading] = useState(false);

  const fetchData = async () => {
    try {
      const reportData = await getReport(id);
      if (reportData === undefined) {
        navigate("/");
      }
      // console.log(reportData);
      generateHcs(reportData);
      generateTags(reportData);
      setLoading(false);
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    setSection(tab);
    if (Object.keys(report).length === 0 && !loading) {
      setLoading(true);
      fetchData();
    }
    else {
      setLoading(false);
    }
  }, [tab]);

  const toggleComments = (value) => {
    setCommentsOpen(value ? value : !commentsOpen);
  };

  const brands = (() => {
    // console.log(report.competitors.split(",").map(competitor => competitor.charAt(0).toUpperCase() + competitor.slice(1)));
    // let comp = [
    //   "Client",
    //   "Competitor 1",
    //   "Competitor 2",
    //   "Competitor 3",
    //   "Competitor 4",
    // ]
    // if (report.competitors && report.competitors !== '') {
    //   console.log(report.competitors);
    //   const competitorsArray = report.competitors.split(",");
    //   competitorsArray.forEach((competitor, index) => {
    //     comp[index + 1] = competitor.charAt(0).toUpperCase() + competitor.slice(1);
    //   });
    // }
    // // let comp = report.competitors !== '' ? report.competitors.split(",").map(competitor => competitor.charAt(0).toUpperCase() + competitor.slice(1)) : [];
    // console.log(comp);
    // return [
    //   "Client",
    //   ...comp
    // ]
    if (!report["cp_comp_rankings"]) {
      return ["", "", "", "", ""];
    }

    return Object.keys(report["cp_comp_rankings"][0]).filter(
      (e) => e !== "category"
    );
  })();

  const sections = generateSections({ report, brands });
  const currentSection = sections.find((s) => s.id === section);

  return (
    <>
      <NavigationScrollListener
        className={`report-container ${currentSection.className ?? ""}`}
      >
        <div className="report-inner">
          <section className="report-hero">
            <div className="report-hero__heading">
              <div className="report-hero__heading-title">
                <h1 className="report-hero__heading-title">
                  {currentSection?.title}
                </h1>
                <Icon icon="information_line" />
              </div>
              <Button
                className="report-hero__heading-comments"
                iconBefore="chat_1_line"
                variant="secondary"
                onClick={toggleComments}
              >
                Report Commentary
              </Button>
            </div>
            {currentSection.description && (
              <div className="report-hero__description">
                {currentSection.description}
              </div>
            )}
          </section>
          <section className="report-view">
            <div className={"report-view__data"}>
              {currentSection?.sections?.map((block, i) => {
                return (
                  <Block
                    key={i}
                    sectionData={block}
                    report={report}
                    loading={loading}
                  />
                );
              })}
            </div>
          </section>
        </div>
        <Footer />
      </NavigationScrollListener>
      <CommentsPanel isOpen={commentsOpen} onClose={toggleComments} />
    </>
  );
}
